import React from 'react';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  return <div className="pt-28" data-id="element-491">
      <ContactSection data-id="element-492" />
    </div>;
}